import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";
import Point from "slotworks/utils/geom/point";
import ReelComponent from "../../reel-component";

export default class ReelSymbolRemover {

    protected reel: ReelComponent;
    protected allSymbols: SymbolComponent[];

    constructor(reel: ReelComponent, stops: number[], reelset: string[][]) {
        this.reel = reel;
        this.allSymbols = this.reel.getSymbols();
    }

    public removeSymbols(positions: Point[]): Contract<void> {
        return new Parallel(this.createRemoveAnimateContracts(positions));
    }

    public skip(positions: Point[]): void {
        positions.forEach((point: Point) => {
            const symbol: SymbolComponent = this.allSymbols[point.y];
            symbol.static();
            symbol.updateTransform();
            symbol.setVisible(false);
        });
    }

    protected createRemoveAnimateContracts(positions: Point[]): Array<() => Contract<void>> {
        const removeAnimateContracts: Array<() => Contract<void>> = [];
        positions.forEach((point: Point) => removeAnimateContracts.push(() => this.allSymbols[point.y].remove()));
        return removeAnimateContracts;
    }
}
